import React from 'react'
import styled from 'styled-components'
import CardTypeTiny from '../CardTypeTiny'
const CardWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: auto;
    margin-bottom: 1rem;

    border-bottom:1px solid #5A5A5A;
`
const Box = styled.div`
`
const Row = styled.div`

    display:flex;
    justify-content: space-between;

    .remove_space{
        height: 15px;
    }


`
const BoxText = styled.div`
    margin-bottom: 1.2rem;
    height:2rem;
    min-width: 230px;

    p{
        font-size: 0.9rem;
        font-family: "Poppins";
        font-weight: 500;
        height: 0.2rem;
    }

    .textPrimary{
        font-size: 1rem;
        font-family: "Poppins";
        font-weight: 600;
    }


`
const Line = styled.div`
    display:flex;
    align-items: center;
    
    div{
        margin-right: 3.9rem;
    }

`
const Clean = styled.div`
    height: 5rem;

`


const CardDataServiceTiny = ({ numberItens, products }) => {

    const reducePrice = products.reduce(
        (acc, item) => acc + Number(item.price) * Number(item.quantity),
        0
    );


    return (
        <CardWrapper>

            <Row>
                <Box>
                    <BoxText>
                        <CardTypeTiny />

                    </BoxText>
                    <Clean />
                    <Line>
                        <BoxText>
                            <p>Nº de itens</p>
                            <p className='textPrimary'>{numberItens}</p>

                        </BoxText>
                        <Line>
                            <BoxText>
                                <p>Soma das qtdes</p>
                                <p className='textPrimary'>R$ {Number(reducePrice).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</p>

                            </BoxText>
                        </Line>

                        <Line>
                            <BoxText>
                                <p>Peso Bruto</p>
                                <p className='textPrimary'>Kg</p>

                            </BoxText>
                        </Line>
                    </Line>
                    <Line>
                        <BoxText>
                            <p>Total produtos</p>
                            <p className='textPrimary'>R$ {Number(reducePrice).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</p>

                        </BoxText>
                        <Line>
                            <BoxText>
                                <p>Valor IPI</p>
                                <p className='textPrimary'>R$ 0,00</p>

                            </BoxText>
                        </Line>

                        <Line>
                            <BoxText>
                                <p>Valor ICMS ST + FCP ST</p>
                                <p className='textPrimary'>R$ 0,00</p>

                            </BoxText>
                        </Line>

                    </Line>

                </Box>

            </Row>


        </CardWrapper>
    )
}

export default CardDataServiceTiny